import React from 'react';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_MY_DETAILS_QUERY = gql`
  query GetMyDetails {
    getMyDetails {
      tenant {
        Timezone
      }
      user {
        ...GetMyDetailsUserFragment_User
      }
    }
  }
` as import('../../__generated__/ts-gql/GetMyDetails').type;

export const GetMyDetailsUserFragment = gql`
  fragment GetMyDetailsUserFragment_User on User {
    cloudId
    fullName
    email
    active
    workflowRole
    administrator
    licensed
    roleName
    partner
    manager
  }
` as import('../../__generated__/ts-gql/GetMyDetailsUserFragment_User').type;

export type GetMyDetailsQueryVariables = OperationVariables<
  typeof GET_MY_DETAILS_QUERY
>;

export type GetMyDetailsQueryResult = OperationData<
  typeof GET_MY_DETAILS_QUERY
>;

export type GetMyDetailsQueryItem = GetMyDetailsQueryResult['getMyDetails'];

export type GetMyDetailsQueryTenant = NonNullable<
  Pick<NonNullable<GetMyDetailsQueryItem>, 'tenant'>['tenant']
>;

export type GetMyDetailsQueryUser = NonNullable<
  Pick<NonNullable<GetMyDetailsQueryItem>, 'user'>['user']
>;

export const useGetMyDetails = () => {
  const res = useQuery(GET_MY_DETAILS_QUERY, {
    context: { service: 'users' },
  });

  return React.useMemo(
    () => ({
      ...res,
      data: res.data?.getMyDetails,
    }),
    [res]
  );
};
